import script from "./machine-card.vue?vue&type=script&setup=true&lang=ts"
export * from "./machine-card.vue?vue&type=script&setup=true&lang=ts"

import "./machine-card.vue?vue&type=style&index=0&id=3f9c57ee&scoped=true&lang=stylus"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f9c57ee"]])

export default __exports__